module.exports = __webpack_public_path__ + "img/logo-blanco.defce46b.png";